var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { CapabilitiesKeyFactory } from '#query-hooks';
export const useGetGuestLinksCapabilities = ({ workspaceId, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    return useQuery({
        queryFn: async () => {
            const capabilities = await lucidSdk
                .workspaceClient(workspaceId)
                .billing()
                .getCapabilities({ guestLinks: true });
            return capabilities.capabilities.guestLinks;
        },
        queryKey: CapabilitiesKeyFactory.guestLinksCapabilities(workspaceId),
        networkMode: 'always',
        retry: 1,
    });
};
_react_refresh_temp_1(useGetGuestLinksCapabilities, "Pdgrl5enHnzcAwRFvHrztXm3QfI=", false, () => [useLucidSdk, useQuery]);
